import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import axios from "axios";
import {
  deleteCustomerNew,
  fetchCustomersNew,
  refreshCustomer,
  createCustomer,
  updateCustomer,
  fetchThreatAnalyst,
  updateScan
} from "../../actions/customer";
import { API_URL, IMAGE_URL } from "../../utils/constant";
import { Link } from "react-router-dom";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import DatePicker from "react-datepicker";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import "../../assets/css/dropdown.css"; // Import the new dropdown CSS file
// import { API_URL } from "../../utils/constant";
var Model = require("../information/model");

const Clients = () => {
  const dispatch = useDispatch();
  const dropdownRefs = useRef({});

  const auth = useSelector((state) => state?.auth?.user);
  const [orgId, setOrgId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isModal, setModal] = useState("");
  const [refreshModal, setRefreshModal] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState("");
  const [scanConfigModal, setScanConfigModal] = useState(false);
  const [selectedClientForScanConfig, setSelectedClientForScanConfig] = useState(null);
  const [services, setServices] = useState([]);
  var date = new Date();
  date = moment(date).add(1, "year").toDate();
  const [expiredAt, selectDate] = useState(date);
  const [status, setStatus] = useState("all");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(1);
  const [firstLoad, setFirstLoad] = useState(true);
  const [PageSize, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [scanType, setscanType] = useState("No");
  const [scanScheduleDay, setscanScheduleDay] = useState("Sunday");
  const [scanModule, setScanModule] = useState(["All"]);

  const [orgName, setOrgName] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgContactName, setOrgContactName] = useState("");
  const [orgContact, setOrgContact] = useState("");
  const [website, setWebsite] = useState("");
  const [emailAccess, setEmailAccess] = useState(false);
  const [clientType, setClientType] = useState("1"); // Default to Client (id: 1)
  const [plan, setPlan] = useState("basic");
  const [industryType, setindustryType] = useState("Government");
  const [domains, setDomain] = useState([]);
  const [authMethod, setAuthMethod] = useState("default");
  const [assignTo, setAssignTo] = useState("");
  const [serverType, setServerType] = useState("");
  const [loginUrl, setLoginUrl] = useState("");
  const [logo, setLogo] = useState("");
  const [subscriptionType, setSubscriptionType] = useState("lite"); // Default to lite
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [loginPage, setLoginPage] = useState("");

  const [facebookUrl, setFacebookUrl] = useState("");
  const [twitterUrl, setTwitterUrl] = useState("");
  const [linkedinUrl, setLinkedinUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");

  const [keyWord, setKeyword] = useState("");
  const [license, setLicense] = useState("");

  const [attackSurface, setAttackSurface] = useState("");
  const [dataExposure, setDataExposure] = useState("");
  const [brandSecurity, setBrandSecurity] = useState("");

  // Available scan frequencies
  const scanFrequencies = ["daily", "bi-weekly", "weekly", "monthly", "never"];

  // Default scan configuration structure
  const getDefaultScanConfiguration = () => ({
    attackSurface: {
      ipDiscovery: "never",
      subDomainEnumeration: "never",
      spfAndDmarc: "never"
    },
    dataExposure: {
      leakedCredentials: "never",
      leakedSessions: "never",
      malware: "never",
      leakedSourceCode: "never",
      pastebinSearch: "never",
      breachedPersonalInformation: "never",
      telegramMonitoring: "never",
      postmanMonitoring: "never",
      openCloudBuckets: "never",
      darkWebMonitoring: "never"
    },
    brandSecurity: {
      brandMentions: "never",
      lookAlike: "never",
      rogueMobile: "never",
      socialMediaProfiles: "never"
    }
  });

  // Scan Configuration State - Dynamic structure
  const [scanConfiguration, setScanConfiguration] = useState(getDefaultScanConfiguration());

  // Dynamic function to get scan configuration value
  const getScanConfigValue = (category, field, defaultValue = "never") => {
    // Only use scanConfiguration without msspScanConfig
    return scanConfiguration?.[category]?.[field] || defaultValue;
  };

    // Dynamic function to render scan frequency options
  const renderScanFrequencyOptions = () => {
    return scanFrequencies.map(freq => (
      <option key={freq} value={freq}>{freq}</option>
    ));
  };

  // Dynamic function to update scan configuration
  const updateScanConfigurationDynamic = (category, field, value) => {
    setScanConfiguration(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [field]: value
      }
    }));
  };

  // Dynamic function to merge scan configurations
  const mergeScanConfigurations = (config1, config2) => {
    return {
      attackSurface: { ...config1?.attackSurface, ...config2?.attackSurface },
      dataExposure: { ...config1?.dataExposure, ...config2?.dataExposure },
      brandSecurity: { ...config1?.brandSecurity, ...config2?.brandSecurity }
    };
  };

  // Configuration State for detailed scan config view
  const [showDetailedScanConfig, setShowDetailedScanConfig] = useState(false);

  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  // Initialize VIP entities as an empty array
  const [vipEntities, setVipEntities] = useState([]);

  const handleEntityChange = (index, field, value) => {
    const newEntities = [...vipEntities];
    newEntities[index][field] = value;
    setVipEntities(newEntities);
  };

  const handleSocialMediaChange = (entityIndex, profileIndex, field, value) => {
    const newEntities = [...vipEntities];
    if (Array.isArray(newEntities[entityIndex].socialMediaProfiles) && newEntities[entityIndex].socialMediaProfiles[profileIndex]) {
      newEntities[entityIndex].socialMediaProfiles[profileIndex][field] = value;
      setVipEntities(newEntities);
    }
  };

  const addSocialMediaProfile = (index) => {
    const newEntities = [...vipEntities];
    if (!Array.isArray(newEntities[index].socialMediaProfiles)) {
      newEntities[index].socialMediaProfiles = [];
    }
    newEntities[index].socialMediaProfiles.push({ username: '', platform: '' });
    setVipEntities(newEntities);
  };

  const removeSocialMediaProfile = (entityIndex, profileIndex) => {
    const newEntities = [...vipEntities];
    if (Array.isArray(newEntities[entityIndex].socialMediaProfiles)) {
      newEntities[entityIndex].socialMediaProfiles.splice(profileIndex, 1);
    }
    setVipEntities(newEntities);
  };

  const addNewEntity = () => {
    setVipEntities([...vipEntities, { name: '', email: '', position: '', socialMediaProfiles: [{ username: '', platform: '' }] }]);
  };

  const removeEntity = (index) => {
    const newEntities = vipEntities?.filter((_, i) => i !== index);
    // Set the entities to the filtered result, even if it's an empty array
    setVipEntities(newEntities);
    // This will allow sending an empty array to the backend when all entities are deleted
  };

  // Scan Configuration Functions
  const updateScanConfiguration = (category, subcategory, value) => {
    setScanConfiguration(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [subcategory]: value
      }
    }));
  };



  const openScanConfigModal = (client) => {
    setSelectedClientForScanConfig(client);
    setScanConfigModal(true);
  };

  const saveScanConfiguration = async () => {
    if (selectedClientForScanConfig?._id) {
      setScanConfigModal(false);
      setSelectedClientForScanConfig(null);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // You can send `vipEntities` to your API here
  };

  const availableService = [
    "AttackSurface", "Data Exposure", "BrandSecurity", "TPSA"
  ]


  const user = JSON.parse(localStorage.getItem("user"));
  const isMSSP = user.accessLevel === "mssp";

  let clientTypeData = [];
  // Show both Client and MSSP options for non-MSSP users, only Client for MSSP users
  if (user.accessLevel === "mssp") {
    clientTypeData = [{ id: 1, text: "Client" }];
  } else {
    clientTypeData = [
      { id: 1, text: "Client" },
      { id: 3, text: "MSSP" },
    ];
  }

  let subscriptionTypeData = [];
  let subscriptionValueMSSP = [
    { val: "", text: "MSSP Subscription Type" },
    { val: "trial", text: "Trial" },
    { val: "regular", text: "Regular Client" },
    { val: "lite", text: "Lite" },
  ];
  let subscriptionValueClient = [
    { val: "", text: "Subscription Type" },
    // {val: "trial", text: "Trial" },
    // {val: "one-time", text: "One time" },
    // {val: "gold", text: "Gold" },
    { val: "platinum", text: "Platinum" },
    { val: "lite", text: "Lite" },
  ];
  if (user.accessLevel === "mssp") {
    if (
      user.organisationId
        ?.subscriptionType == "trial"
    ) {
      subscriptionValueMSSP = [
        { val: "", text: "Subscription Type" },
        { val: "trial", text: "Trial" },
      ];
    } else {
      subscriptionValueMSSP = [
        { val: "", text: "Subscription Type" },
        // {val: "trial", text: "Trial" },
        // {val: "one-time", text: "One time" },
        // {val: "gold", text: "Gold" },
        { val: "platinum", text: "Platinum" },
        { val: "lite", text: "Lite" },
      ];
    }
  }

  // Update subscription type based on user access level
  if (user.accessLevel === "super-admin") {
    // For super-admin, show both platinum and lite options
    subscriptionTypeData = subscriptionValueClient; // Already contains both platinum and lite
  } else if (user.accessLevel === "mssp") {
    // For MSSP, show lite by default and use MSSP subscription values
    subscriptionTypeData = subscriptionValueMSSP;
  } else {
    // For other user types, use client subscription values
    subscriptionTypeData = subscriptionValueClient;
  }

  // Set default subscription type based on user access level
  useEffect(() => {
    if (user.accessLevel === "mssp") {
      setSubscriptionType("lite");
    }
  }, [user.accessLevel]);

  let customers = useSelector((state) => state?.customer?.response?.data) || [];
  let customersTotal = useSelector((state) => state?.customer?.customerTotal?.currentCount);
  const threatAnalyist = useSelector(
    (state) => state?.customer?.threatAnalyist
  );
  if (threatAnalyist && threatAnalyist.length > 0 && assignTo == "") {
    setAssignTo(threatAnalyist[0]._id);
  }
  useEffect(() => {
    fetchCustomersNew(dispatch, page, limit, search, filterData);
  }, [page, limit, search, filterData]);

  useEffect(() => {
    fetchThreatAnalyst(dispatch);
  }, [])

  // No MSSP specific scan configuration needed

  // Function to show detailed scan configuration modal
  const showDetailedScanConfigModal = () => {
    // Use scanConfiguration data
    if (scanConfiguration) {
      setShowDetailedScanConfig(true);
    } else {
      // If no data available, show a message
      toastr.warning("Warning", "Scan configuration data not available. Please try again.");
    }
  };

  useEffect(() => {
    setTotalItems(customersTotal)
  }, [customersTotal])

  let clientList = [],
    msspList = [];
  for (let count = 0; count < customers?.length; count++) {
    if (customers[count].clientType == 1) {
      clientList.push(customers[count]);
    }
  }
  if (Array.isArray(customers)) {
    for (let count = 0; count < customers?.length; count++) {
      if (customers[count].clientType == 3) {
        msspList.push(customers[count]);
      }
    }
  }
  let mapData = customers || [];

  mapData =
    search == ""
      ? mapData
      : (Array.isArray(mapData) ? mapData : [])?.filter(
        (row) =>
          row?.orgName?.toLowerCase()?.indexOf(search?.toLowerCase()) != -1 ||
          row?.orgContactName
            ?.toLowerCase()
            ?.indexOf(search?.toLowerCase()) != -1 ||
          row?.orgEmail?.toLowerCase()?.indexOf(search?.toLowerCase()) != -1
      );

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    // setFirstLoad(false)
    const firstPageIndex = (page - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    currentTableData = mapData;
  }
  const downloadCsvData = (Array.isArray(customers) ? customers : [])?.map((res) => ({
    Client: res?.orgName,
    PrimaryContactName: res?.orgContactName,
    Email: res?.orgEmail,
    Contact: res?.orgContact,
    Website: res?.website,
  }));

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
  };

  const handleClick = (id) => {
    if (id == "keyword") {
      let val = $("#keyword").val();
      let _keyWord = keyWord || [];
      if (plan == "pro" && _keyWord.length >= 5) {
        toastr.error("Error", "Maximum keyword limit reached for this plan.");
        return false;
      }
      if (plan == "corporate" && _keyWord.length >= 50) {
        toastr.error("Error", "Maximum keyword limit reached for this plan.");
        return false;
      }
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#keyword").val("");
      setKeyword([..._keyWord, val]);
    } else if (id == "facebook") {
      let val = $("#facebookUrl").val();
      let _keyWord = facebookUrl || [];
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#facebookUrl").val("");
      setFacebookUrl([..._keyWord, val]);
    } else if (id == "linkedin") {
      let val = $("#liknedinUrl").val();
      let _keyWord = linkedinUrl || [];
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#liknedinUrl").val("");
      setLinkedinUrl([..._keyWord, val]);
    } else if (id == "twitter") {
      let val = $("#twitterUrl").val();
      let _keyWord = twitterUrl || [];
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#twitterUrl").val("");
      setTwitterUrl([..._keyWord, val]);
    } else if (id == "instagram") {
      let val = $("#instagramUrl").val();
      let _keyWord = instagramUrl || [];
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#instagramUrl").val("");
      setInstagramUrl([..._keyWord, val]);
    } else {
      let val = $("#domain").val();
      let _domains = domains || [];

      // Add domain limits based on plan
      if (plan === "basic" && _domains.length >= 1) {
        toastr.error("Error", "Basic plan allows only 1 domain.");
        return false;
      }
      if (plan === "pro" && _domains.length >= 5) {
        toastr.error("Error", "Pro plan allows maximum 5 domains.");
        return false;
      }
      // if (plan === "corporate" && _domains.length >= 50) {
      //   toastr.error("Error", "Corporate plan allows maximum 50 domains.");
      //   return false;
      // }

      if (_domains.indexOf(val) != -1) {
        toastr.error("Error", "This domain is already added.");
        return false;
      }
      var re = new RegExp(
        /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/
      );
      var valid = val.match(re);
      if (valid) {
        $("#domain").val("");
        setDomain([..._domains, val]);
      } else {
        toastr.error("Error", "Please enter a valid domain.");
        return false;
      }
    }
  };
  const removeKeyword = (_id, _keyword) => {
    if (_id == "keyword") {
      let newkeyword = keyWord;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setKeyword([...newkeyword]);
    } else if (_id == "facebook") {
      let newkeyword = facebookUrl;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setFacebookUrl([...newkeyword]);
    } else if (_id == "linkedin") {
      let newkeyword = linkedinUrl;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setLinkedinUrl([...newkeyword]);
    } else if (_id == "twitter") {
      let newkeyword = twitterUrl;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setTwitterUrl([...newkeyword]);
    } else if (_id == "instagram") {
      let newkeyword = instagramUrl;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setInstagramUrl([...newkeyword]);
    } else {
      let _domain = domains;
      _domain.splice(_domain.indexOf(_keyword), 1);
      setDomain([..._domain]);
    }
  };

  const removeLogo = () => {
    setLogo("");
    // Clear the file input as well
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      toastr.error("Error", "Please select a file");
      return;
    }

    // Validate file type
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      toastr.error("Error", "Please select a valid image file (JPG, PNG, GIF)");
      return;
    }

    // Validate file size (e.g., max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      toastr.error("Error", "File size should be less than 5MB");
      return;
    }

    // Set the logo file locally first
    setLogo(file);

    // If we have an organisation ID (editing mode), upload immediately
    if (orgId) {
      try {
        await uploadLogo(file, orgId);
      } catch (error) {
        // console.error removed
        // Keep the file in state even if upload fails, user can retry
      }
    } else {
      // If no orgId yet (creation mode), the logo will be uploaded when form is submitted
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
    }
  };

  const hasValidVipEntities = (entities) => {
    return entities.some(entity => {
      const hasMainValues = entity.name.trim() || entity.email.trim() || entity.position.trim();
      const hasSocialMediaValues = Array.isArray(entity.socialMediaProfiles) && entity.socialMediaProfiles.some(profile =>
        profile.username.trim() || profile.platform.trim()
      );

      return hasMainValues || hasSocialMediaValues;
    });
  };

  const normalizeEmailValue = (emailValue) => {
    if (Array.isArray(emailValue)) {
      return emailValue[0] || "";
    }
    return emailValue || "";
  };

  const normalizeVipEntities = (entities = []) => {
    return entities.map(entity => ({
      ...entity,
      email: normalizeEmailValue(entity?.email),
      socialMediaProfiles: Array.isArray(entity?.socialMediaProfiles) 
        ? entity.socialMediaProfiles 
        : []
    }));
  };



  const createJsonData = (data) => {
    const jsonData = {};
    
    Object.keys(data).forEach(key => {
      const value = data[key];
      
      if (value instanceof File) {
        // Skip file objects for JSON - handle separately if needed
      } else if (Array.isArray(value)) {
        // Handle arrays
        jsonData[key] = value;
      } else if (typeof value === 'object' && value !== null) {
        // Handle objects
        if (key === 'scanConfiguration') {
          // Special handling for scan configuration to prevent corruption
          const cleanConfig = {
            attackSurface: value.attackSurface || {},
            dataExposure: value.dataExposure || {},
            brandSecurity: value.brandSecurity || {}
          };
          jsonData[key] = cleanConfig;
        } else {
          jsonData[key] = value;
        }
      } else if (value !== null && value !== undefined) {
        // Handle primitive values
        jsonData[key] = value;
      }
    });
    
    return jsonData;
  };

  const updateCustomerWithJsonData = async (jsonData, dispatch) => {
    const session = localStorage.getItem("session");
    
    try {
      dispatch({
        type: "UPDATING_CUSTOMER",
        payload: null,
      });

      const response = await axios.put(`${API_URL}/customer`, jsonData, {
        headers: {
          'Authorization': `Bearer ${session}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
        dispatch({
          type: "CUSTOMER_UPDATED",
          payload: { error: true, userMessage: response.data.userMessage },
        });
        return Promise.reject(response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
        dispatch({
          type: "CUSTOMERS_FETCHED",
          payload: response.data,
        });
        return Promise.resolve();
      }
    } catch (err) {
      let message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
        toastr.error("Error", message);
      }
      dispatch({
        type: "CUSTOMER_UPDATED",
        payload: { error: true, userMessage: message },
      });
      return Promise.reject(message);
    }
  };

  const createCustomerWithJsonData = async (jsonData, auth, dispatch) => {
    const session = localStorage.getItem("session");
    
    try {
      dispatch({
        type: "CREATING_CUSTOMER",
        payload: null,
      });

      const response = await axios.post(`${API_URL}/customer`, jsonData, {
        headers: {
          'Authorization': `Bearer ${session}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
        dispatch({
          type: "CUSTOMER_CREATED",
          payload: { error: true, userMessage: response.data.userMessage },
        });
        return Promise.reject(response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
        dispatch({
          type: "CUSTOMERS_FETCHED",
          payload: response.data,
        });
        return Promise.resolve(response);
      }
    } catch (err) {
      let message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
        toastr.error("Error", message);
      }
      dispatch({
        type: "CUSTOMER_CREATED",
        payload: { error: true, userMessage: message },
      });
      return Promise.reject(message);
    }
  };

  const submitForm = () => {
    if (scanType !== "weekly") {
      setscanScheduleDay("");
    }

    if (orgName == "") {
      toastr.error("Error", "Please enter organisation name.");
      return false;
    }
    if (orgContactName == "") {
      toastr.error("Error", "Please enter contact name.");
      return false;
    }
    var regex =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    if (!regex.test(website)) {
      toastr.error("Error", "Website address is incorrect.");
      return false;
    }
    if (country == '') {
      toastr.error("Error", "Please select the country.");
      return false;
    }
    if (industryType == '') {
      toastr.error("Error", "Please select the industry type.");
      return false;
    }
    // if(emailAccess == ""){
    //   toastr.error("Error", "Please select email access.");
    //   return false;
    // }
    if (clientType == "") {
      toastr.error("Error", "Please select client type.");
      return false;
    }
    if (industryType == "") {
      toastr.error("Error", "Please select Industry.");
      return false;
    }
    if (subscriptionType == "") {
      toastr.error("Error", "Please select subscription level.");
      return false;
    }

    if (isEdit) {
      const updateData = {
        orgName,
        orgEmail: normalizeEmailValue(orgEmail),
        orgContact,
        website,
        loginPage,
        emailAccess,
        plan,
        clientType,
        domains,
        authMethod,
        scanType,
        scanScheduleDay,
        scanModule,
        logo,
        removeLogo: logo === "",
        subscriptionType,
        address,
        country,
        state,
        city,
        facebookUrl,
        twitterUrl,
        linkedinUrl,
        instagramUrl,
        keyWord,
        orgId,
        orgContactName,
        expiredAt: expiredAt ? expiredAt.toISOString() : null,
        serverType,
        loginUrl,
        industryType,
        license,
        services,
        attackSurface,
        dataExposure,
        brandSecurity,
        scanConfiguration: (() => {
          const config = scanConfiguration || getDefaultScanConfiguration();
          
          // Ensure we're sending an object, not a string
          if (typeof config === 'string') {
            try {
              const parsed = JSON.parse(config);
              return parsed;
            } catch (e) {
              // console.error removed
              return getDefaultScanConfiguration();
            }
          }
          
          return config;
        })()
      };
      
      // Always send vipEntities to the backend, even if they are empty
      updateData.vipEntities = normalizeVipEntities(vipEntities);
      
      const jsonData = createJsonData(updateData);
      
      // Add customerId to JSON data
      jsonData.customerId = orgId;
      
      
      updateCustomerWithJsonData(jsonData, dispatch)
        .then(() => {
          fetchCustomersNew(dispatch, page, limit, search, filterData);
          setModal("");
        })
        .catch(() => {
        });
    } else {
      const customerData = {
        industryType,
        scanType,
        scanScheduleDay,
        scanModule,
        orgName,
        orgEmail: normalizeEmailValue(orgEmail),
        orgContact,
        website,
        loginPage,
        emailAccess,
        plan,
        clientType,
        domains,
        authMethod,
        logo,
        removeLogo: logo === "",
        subscriptionType,
        address,
        country,
        state,
        city,
        facebookUrl,
        twitterUrl,
        linkedinUrl,
        instagramUrl,
        keyWord,
        orgContactName,
        expiredAt: expiredAt ? expiredAt.toISOString() : null,
        serverType,
        loginUrl,
        license,
        services,
        attackSurface,
        dataExposure,
        brandSecurity,
        scanConfiguration: (() => {
          const config = scanConfiguration || getDefaultScanConfiguration();
          
          // Ensure we're sending an object, not a string
          if (typeof config === 'string') {
            try {
              const parsed = JSON.parse(config);
              return parsed;
            } catch (e) {
              // console.error removed
              return getDefaultScanConfiguration();
            }
          }
          
          return config;
        })()
      };
      
      // Always send vipEntities to the backend, even if they are empty
      customerData.vipEntities = normalizeVipEntities(vipEntities);
      
      const jsonData = createJsonData(customerData);
      
      createCustomerWithJsonData(
        jsonData,
        auth,
        dispatch
      ).then((response) => {
        setModal("");
      }).catch(() => {
      });
    }
    // setModal("");
  };


  const addModal = () => {
    setIsEdit(false);
    setOrgName("");
    setOrgEmail("");
    setOrgContact("");
    setWebsite("");
    // setEmailAccess("")
    // Set default client type based on user access level
    if (user.accessLevel === "mssp") {
      setClientType("1"); // Default to Client for MSSP users
    } else {
      setClientType("1"); // Default to Client for non-MSSP users (can be changed to "3" for MSSP if needed)
    }
    
    // Set default subscription type based on user access level
    if (user.accessLevel === "mssp") {
      setSubscriptionType("lite"); // Default to lite for MSSP
    } else if (user.accessLevel === "super-admin") {
      setSubscriptionType(""); // Empty for super-admin to allow selection between platinum and lite
    } else {
      setSubscriptionType("lite"); // Default to lite for other users
    }
    setDomain([]);
    setAuthMethod("");
    setAssignTo("");
    setLogo("");
    setAddress("");
    setCountry("");
    setState("");
    setCity("");
    setFacebookUrl("");
    setTwitterUrl("");
    setLinkedinUrl("");
    setInstagramUrl("");
    setKeyword("");
    setOrgContactName("");
    setscanScheduleDay("Sunday");
    setServices(['AttackSurface', 'Data Exposure', 'BrandSecurity', 'TPSA', 'ExecutiveMonitoring', 'RedTeaming', 'ThreatIntelligence'])
    // setServices(["AttackSurface", "DarkWeb", "BrandSecurity"]);
    setscanType("No");
    setAttackSurface("");
    setBrandSecurity("");
    setDataExposure("");
    setVipEntities([]); // Initialize as empty array
    
    // Set default scan configuration values for new client
    setScanConfiguration(getDefaultScanConfiguration());
    
    setModal("Form Wizard modal");
  };

  const editModal = (row) => {
    setIsEdit(true);
    setindustryType(row?.industryType)
    setOrgId(row?._id);
    setOrgName(row?.orgName);
    setOrgEmail(normalizeEmailValue(row?.orgEmail));
    setOrgContact(row?.orgContact);
    setWebsite(row?.website);
    setLoginPage(row?.loginPage);
    setEmailAccess(row?.emailAccess);
    setClientType(row?.clientType);
    setSubscriptionType(row?.subscriptionType);
    setDomain(row?.domains);
    setAuthMethod(row?.authMethod);
    setAssignTo(row?.assignTo);
    setLogo(row?.logo || row?.logoUrl);
    setscanScheduleDay(row?.scanScheduleDay);
    setScanModule(row?.scanModule || ["All"]);
    // setSubscriptionType(row?.subscriptionType)
    setAddress(row?.address);
    setCountry(row?.country);
    setState(row?.state);
    setCity(row?.city);
    setscanType(row?.scanType);
    setFacebookUrl(row?.facebookUrl);
    setTwitterUrl(row?.twitterUrl);
    setLinkedinUrl(row?.linkedinUrl);
    setInstagramUrl(row?.instagramUrl);
    setKeyword(row?.keyWord);
    setOrgContactName(row?.orgContactName);
    selectDate(row?.expiredAt ? new Date(row?.expiredAt) : new Date());
    setServerType(row?.serverType);
    setLoginUrl(row?.loginUrl);
    setServices(row?.services || []);
    setPlan(row?.plan || "basic");
    setAttackSurface(row?.attackSurface || "");
    setBrandSecurity(row?.brandSecurity || "");
    setDataExposure(row?.dataExposure || "");
    setModal("Form Wizard modal");
    setVipEntities(normalizeVipEntities(row?.vipEntities || [])); // Use empty array as default

    // Set scan configuration from existing data or use default values
    if (row?.scanConfiguration) {
      // Parse scan configuration if it's a string, otherwise use as-is
      let parsedScanConfig;
      if (typeof row.scanConfiguration === 'string') {
        try {
          parsedScanConfig = JSON.parse(row.scanConfiguration);
        } catch (e) {
          // console.error removed
          parsedScanConfig = getDefaultScanConfiguration();
        }
      } else {
        parsedScanConfig = row.scanConfiguration;
      }
      setScanConfiguration(parsedScanConfig);
    } else {
      // Set default scan configuration values
      setScanConfiguration(getDefaultScanConfiguration());
    }
    
  };

  const deleteCustomerOption = (id) => {
    const self = this;
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to delete this customer?",
      type: "red",
      buttons: {
        ok: {
          text: "Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            deleteCustomerNew(id, dispatch);
            fetchCustomersNew(dispatch, page, limit, search, filterData);
          },
        },
        cancel: function () {
        },
      },
    });
  };
  const toggleScan = (data) => {
    const status = data?.hasActiveVulnerabilityScanningEnabled ? "disable" : "enable";
    $.confirm({
      title: "Are you sure?",
      content: `Do you really want to ${status} the scan?`,
      type: "green",
      buttons: {
        ok: {
          text: "Yes",
          btnClass: "btn-success",
          keys: ["enter"],
          action: function () {
            updateScan(data?._id, dispatch, status);
          },
        },
        cancel: function () {
        },
      },
    });
  }

  // Function to handle dropdown toggle
  const toggleDropdown = (id) => {
    if (dropdownRefs.current[id]) {
      const dropdownMenu = dropdownRefs.current[id].querySelector('.dropdown-menu');
      dropdownMenu.classList.toggle('show');
    }
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.keys(dropdownRefs.current).forEach(key => {
        if (dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)) {
          const dropdownMenu = dropdownRefs.current[key].querySelector('.dropdown-menu');
          if (dropdownMenu.classList.contains('show')) {
            dropdownMenu.classList.remove('show');
          }
        }
      });
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Add state for selected client type
  const [selectedClientType, setSelectedClientType] = useState('');

  // Function to handle client type change
  const handleClientTypeChange = (clientType) => {
    setSelectedClientType(clientType);
    
    // Set subscription type based on user access level and client type
    if (user.accessLevel === "mssp") {
      // MSSP users always get 'lite' subscription type
      setSubscriptionType('lite');
    } else if (user.accessLevel === "super-admin") {
      // Super-admin users can choose between platinum and lite, so we don't set a default here
      // The form validation will ensure they select one
      setSubscriptionType('');
    } else {
      // Other users get 'lite' by default
      setSubscriptionType('lite');
    }
  };

  const uploadLogo = async (file, organisationId) => {
    try {
      const session = localStorage.getItem("session");
      const formData = new FormData();
      formData.append('logo', file);

      const response = await axios.post(`${API_URL}/organisation/${organisationId}/upload-logo`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${session}`,
        }
      });

      if (response.data) {
        toastr.success("Success", response.data.userMessage );
        return response.data;
      }
    } catch (error) {
      // console.error removed
      let message = "Failed to upload logo";
      if (error.response && error.response.data && error.response.data.userMessage) {
        message = error.response.data.userMessage;
      }
      toastr.error("Error", message);
      throw error;
    }
  };

  const handleLogoUpload = async (event, organisationId) => {
    const file = event.target.files[0];
    if (!file) {
      toastr.error("Error", "Please select a file");
      return;
    }

    // Validate file type
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      toastr.error("Error", "Please select a valid image file (JPG, PNG, GIF)");
      return;
    }

    // Validate file size (e.g., max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      toastr.error("Error", "File size should be less than 5MB");
      return;
    }

    try {
      await uploadLogo(file, organisationId);
      // Refresh the client data or update UI as needed
    } catch (error) {
      // Error is already handled in uploadLogo function
    }
  };

  return (
    <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Dashboard</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/" className="welcome-textSmall">Home</Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  {auth?.organisationId?._id === "689d805ea2a8b086e848d6c8" ? "Manage Scan" : "Clients"}
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 d-flex justify-content-end">
            {auth?.accessLevel != "Threat Analyst" && auth?.organisationId?._id !== "689d805ea2a8b086e848d6c8" && (
              <button
                type="button"
                className="btn btn-trans btnVendor mx-2"
                style={{ color: "black", fontWeight: "bold", height: "45px" }}
                onClick={() => addModal()}
              >
                + Add New
              </button>
            )}
            {customers?.length === 0 ? null : (
              <a
                onClick={(e) => {
                  e.preventDefault();
                  exportToCSV(downloadCsvData, "Client List");
                }}
                style={{
                  float: "right",
                  color: "black",
                  fontWeight: "bold",
                }}
                href="/add-report"
                className="btn btn-primary mr-1 download-report"
              >
                Download Details
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-12 col-md-12">
          <div className="card">
            <div className="body">
              <div className="row clearfix mb-2">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="searchBoxInput p-0">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Client Name"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(1);
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <div className="input-group">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      style={{ width: "200px" }}
                      value={filterData}
                      onChange={(e) => setfilterData(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="1">Clients</option>
                      <option value="3">MSSP</option>
                      <option value="forestView">Forest View</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                {currentTableData?.length === 0 ? (
                  <div className="text-center py-5">
                    <h4>No Clients Found</h4>
                    <p>Please add your first client to get started</p>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => addModal()}
                    >
                      + Add New Client
                    </button>
                  </div>
                ) : (
                  <table className="table table-custom spacing5 mb-0">
                    <tbody>
                      <tr>
                        <th>#</th>
                        <th>Customer Name</th>
                        <th>Client Type</th>
                        <th>Subscription Type</th>
                        {/* <th>Email Address</th> */}
                        {/* <th>Websites</th> */}
                        <th>Registered on</th>
                        <th>Actions</th>
                      </tr>
                      {currentTableData?.map((item, index) => {
                      return (
                        <tr>
                          <td>
                            <span>{(page - 1) * 10 + 1 + index}</span>
                          </td>
                          <td>
                            <Link
                              to={`/user/${item._id}`}
                              title=""
                              style={{ color: "white" }}
                            >
                              {item.orgName}
                            </Link>
                            <p className="mb-0">{item.orgContactName}</p>
                          </td>
                          <td>
                            <span className="badge badge-warning">
                              {item.clientType == 1 ? "Client" : "MSSP"}
                            </span>
                          </td>
                          <td>
                            <td>
                              <span className="badge badge-success">
                                {item.subscriptionType}
                              </span>
                            </td>
                          </td>



                          <td>
                            <span>
                              {" "}
                              {moment(item.createdAt).format(
                                "DD/MM/YYYY hh:mm a"
                              )}{" "}
                            </span>
                          </td>
                          <td>
                            {auth?.accessLevel != "Threat Analyst" && (
                              <div className="dropdown dropdownLatestMulti" ref={el => dropdownRefs.current[item._id] = el}>
                                <button type="button" className="btn p-0 dropdown-toggle-dots"
                                  onClick={() => toggleDropdown(item._id)}
                                >
                                  <div className="dropDownDot">
                                    <div className="dropdown-dot"></div>
                                    <div className="dropdown-dot"></div>
                                    <div className="dropdown-dot"></div>
                                  </div>
                                </button>
                                <div className="dropdown-menu">
                                  {auth?.accessLevel != "Threat Analyst" && (
                                    <button className="dropdown-item dropDownDotItems" onClick={() => editModal(item)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-pencil dropdown-item-icon" viewBox="0 0 16 16">
                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                                      </svg>
                                      Edit
                                    </button>
                                  )}
                                  {auth?.accessLevel != "Threat Analyst" &&
                                    !isMSSP && (
                                      <button className="dropdown-item dropDownDotItems" onClick={() => {
                                        setSelectedOrgId(item._id);
                                        setRefreshModal(true);
                                      }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-arrow-clockwise dropdown-item-icon" viewBox="0 0 16 16">
                                          <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                          <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                        </svg>
                                        Refresh
                                      </button>
                                    )}
                                  {auth?.accessLevel != "Threat Analyst" && (
                                    <button className="dropdown-item dropDownDotItems" onClick={() => {
                                      deleteCustomerOption(item._id);
                                    }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-trash3 dropdown-item-icon" viewBox="0 0 16 16">
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                      </svg>
                                      Delete
                                    </button>
                                  )}
                                  {auth?.accessLevel == "super-admin" && (
                                    <Link className="dropdown-item dropDownDotItems" to={`/show-details/${item._id}`}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-card-list dropdown-item-icon" viewBox="0 0 16 16">
                                        <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                                        <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                                      </svg>
                                      Show Details
                                    </Link>
                                  )}
                                  <Link className="dropdown-item dropDownDotItems" to={`/user/${item._id}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-person-circle dropdown-item-icon" viewBox="0 0 16 16">
                                      <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                                      <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                                    </svg>
                                    User Access
                                  </Link>
                                  <button className="dropdown-item dropDownDotItems" onClick={() => {
                                    openScanConfigModal(item);
                                  }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-gear dropdown-item-icon" viewBox="0 0 16 16">
                                      <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                                      <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.294l-.424-.16a.874.874 0 0 1-.294-1.254l.13-.473a.874.874 0 0 1 1.255-.294l.424.16c.53.199 1.096.199 1.626 0l.424-.16a.874.874 0 0 1 1.255.294l.13.473a.874.874 0 0 1-.294 1.254l-.424.16a.874.874 0 0 1-1.255-.294l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a.873.873 0 0 1 1.255.294l.424.16c.53.199 1.096.199 1.626 0l.424-.16a.874.874 0 0 1 1.255.294l.13.473a.874.874 0 0 1-.294 1.254l-.424.16a.874.874 0 0 1-1.255-.294l-.094-.319c-.246-.835-1.428-.835-1.674 0l-.094.319a.873.873 0 0 1-1.255.294l-.424-.16a.874.874 0 0 1-.294-1.254l.13-.473a.874.874 0 0 1 1.255-.294l.424.16c.53.199 1.096.199 1.626 0l.424-.16a.874.874 0 0 1 1.255.294l.13.473a.874.874 0 0 1-.294 1.254l-.424.16a.874.874 0 0 1-1.255-.294l-.094-.319z" />
                                    </svg>
                                    Scan Configuration
                                  </button>
                                  {JSON.parse(localStorage.getItem("user"))?.accessLevel === "mssp" && (
                                    <button className="dropdown-item dropDownDotItems" onClick={() => {
                                      showDetailedScanConfigModal();
                                    }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-eye dropdown-item-icon" viewBox="0 0 16 16">
                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.402.719-1.023 1.843-1.01 2.057a1.9 1.9 0 0 1-.325.379c-.548.374-1.038.374-1.548.374H5.5c-.51 0-1-.01-1.548-.374a1.9 1.9 0 0 1-.325-.379c-.013-.214-.608-1.338-1.01-2.057A13.134 13.134 0 0 1 1.172 8z" />
                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                      </svg>
                                      Detailed Scan Configuration
                                    </button>
                                  )}
                                  <button className="dropdown-item dropDownDotItems" onClick={() => toggleScan(item)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-slash-circle dropdown-item-icon" viewBox="0 0 16 16">
                                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                      <path d="M11.354 4.646a.5.5 0 0 0-.708 0l-6 6a.5.5 0 0 0 .708.708l6-6a.5.5 0 0 0 0-.708z" />
                                    </svg>
                                    {item?.hasActiveVulnerabilityScanningEnabled ? "Disable Active" : "Enable Active"}
                                  </button>
                                </div>
                              </div>
                            )}
                          </td>
                          <td></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                )}
              </div>
              <div className="d-flex justify-content-between align-content-center">
                <div className="dataTables_paginate">
                  {totalItems > 0 && (
                    <Pagination
                      className="pagination-bar"
                      currentPage={page}
                      totalCount={totalItems}
                      pageSize={PageSize}
                      onPageChange={(page) => setPage(page)}
                    />
                  )}
                </div>
                {totalItems > 10 && (
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value)
                    }}
                    className="form-control limitSelectBox"
                  >
                    <option value={10}>10 per page</option>
                    <option value={25}>25 per page</option>
                    <option value={50}>50 per page</option>
                    <option value={100}>100 per page</option>
                  </select>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg clientPageModal" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{isEdit ? "Edit Client" : "Add New Client"}</h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal("")}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="header">
                    <h2 style={{ color: "white" }}>Basic Information</h2>
                  </div>
                  <div className="row clearfix">
                    <div className="col-lg-6 col-md-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Client Name *"
                          value={orgName}
                          onChange={(e) => setOrgName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email address *"
                          value={orgEmail}
                          onChange={(e) => setOrgEmail(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Primary Contact Name"
                          value={orgContactName}
                          onChange={(e) => setOrgContactName(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                      <div className="form-group">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="icon-globe"></i>
                            </span>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="http://"
                            value={website}
                            onChange={(e) => setWebsite(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    {auth?.accessLevel == "Admin" && (
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Login page"
                              value={loginPage}
                              onChange={(e) => setLoginPage(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* <div className="col-lg-6 col-md-12">
                      <div className="form-group">
                        <select
                          className="form-control"
                          value="lite"
                          disabled={true}
                          style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
                        >
                          <option value="lite">Lite</option>
                        </select>
                      </div>
                    </div> */}
                    {clientType != 3 && (
                      <div className="col-lg-6 col-md-12">
                        {/* <div className="form-group">
                          <select className="form-control">
                            <option value="">--Domains --</option>
                            <option value="trial">Domain1</option>
                            <option value="one-time">Domain2</option>
                            <option value="gold">Gold</option>
                            <option value="platinum">Platinum</option>
                          </select>
                        </div> */}
                        <div className="form-group d-flex">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Domains"
                            name="domain"
                            id="domain"
                            style={{ float: "left", width: "89%" }}
                          />
                          <button
                            type="button"
                            style={{ float: "left" }}
                            className="btn btn-primary btn-Icon"
                            onClick={() => handleClick("domain")}
                          >
                            <i
                              className="fa fa-plus"
                              style={{ fontSize: "22px", color: "black" }}
                            ></i>
                          </button>
                        </div>
                      </div>
                    )}

                    {!isMSSP ? (
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <select
                            className="form-control"
                            value={emailAccess}
                            onChange={(e) => setEmailAccess(e.target.value)}
                          >
                            {/* <option value="">-- Email Access * --</option> */}
                            <option value={false}>
                              Email access to client?
                            </option>
                            <option value={false}>No</option>
                            <option value={true}>Yes</option>
                          </select>
                        </div>
                      </div>
                    ) : null}
                    {!isMSSP ? (
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <select
                            className="form-control"
                            value={clientType}
                            onChange={(e) => {
                              setClientType(e.target.value);
                              handleClientTypeChange(parseInt(e.target.value));
                            }}
                          >
                            {/* <option value="">-- Select Client Type * --</option> */}
                            {clientTypeData?.map((row) => {
                              return <option value={row.id}>{row.text}</option>;
                            })}
                            {/* <option value="client">Client</option>
                            <option value="mssp">MSSP</option> */}
                          </select>
                        </div>
                      </div>
                    ) : null}
                    <div className="col-lg-6 col-md-12">
                      <div className="form-group">
                        <select
                          className="form-control"
                          value={industryType}
                          onChange={(e) => {
                            setindustryType(e.target.value);
                          }}
                        >
                          <option value="Government">Government</option>
                          <option value="NGO">NGO</option>
                          <option value="Finance">Finance</option>
                          <option value="Technology">Technology</option>
                          <option value="Healthcare">Healthcare</option>
                          <option value="Education">Education</option>
                          <option value="Telecommunications">Telecommunications</option>
                          <option value="Manufacturing">Manufacturing</option>
                          <option value="Construction">Construction</option>
                          <option value="Energy">Energy</option>
                          <option value="Chemical">Chemical</option>
                          <option value="Media">Media</option>
                          <option value="Aerospace">Aerospace</option>
                          <option value="Transportation">Transportation</option>
                          <option value="Agriculture">Agriculture</option>
                          <option value="Retail">Retail</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="form-group">
                        <select
                          className="form-control"
                          value={plan}
                          onChange={(e) => {
                            setPlan(e.target.value);
                          }}
                        >
                          <option value="basic">Basic plan</option>
                          <option value="pro">Pro plan</option>
                          <option value="corporate">Corporate plan</option>
                        </select>
                      </div>
                    </div>
                    
                    {/* Subscription Type dropdown - only show for super-admin users */}
                    {user.accessLevel === "super-admin" && (
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <select
                            className="form-control"
                            value={subscriptionType}
                            onChange={(e) => {
                              setSubscriptionType(e.target.value);
                            }}
                          >
                            {subscriptionTypeData?.map((row) => {
                              return <option key={row.val} value={row.val}>{row.text}</option>;
                            })}
                          </select>
                        </div>
                      </div>
                    )}
                    
                    {/* <div className="col-lg-6 col-md-12 clientCalendar">
                        <div className="form-group">
                          <DatePicker
                            selected={expiredAt}
                            minDate={new Date()}
                            showTimeSelect
                            timeFormat="p"
                            timeIntervals={1}
                            onChange={(date) => selectDate(date)}
                            className="form-control datetimepicker"
                            dateFormat="MMMM d, yyyy h:mm aa"
                          />
                        </div>
                      </div> */}
                    {clientType == 3 && (
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="License"
                            value={license}
                            onChange={(e) => setLicense(e.target.value)}
                          />
                        </div>
                      </div>
                    )}



                    {domains && domains.length > 0 && (
                      <div className="col-lg-6 col-md-12">
                        <div className="row">
                          {domains?.map((keyword) => {
                            return (
                              <div className="col-md-4">
                                <label
                                  style={{
                                    color: "white",
                                    background: "#2e2a74",
                                    padding: "4px 6px",
                                    margin: "0px 5px"
                                  }}
                                >
                                  <span style={{ color: "#fff" }}>
                                    {keyword}{" "}
                                    <span
                                      className="fa fa-times-circle text-white"
                                      onClick={() =>
                                        removeKeyword("domain", keyword)
                                      }
                                    ></span>
                                  </span>
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    {/* <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <select
                            className="form-control"
                            value={authMethod}
                            onChange={(e) => setAuthMethod(e.target.value)}
                          >
                            <option value="default">Default</option>
                            <option value="microsoft">Microsoft</option>
                            <option value="google">Google</option>
                          </select>
                        </div>
                      </div> */}
                    {/* <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <select
                            className="form-control"
                            value={assignTo}
                            onChange={(e) => setAssignTo(e.target.value)}
                          >
                            {threatAnalyist?.map((row) => {
                              return (
                                <option value={row?._id}>
                                  {row?.fullName}
                                </option>
                              );
                            })}
                            <option value="default">Analyst 1</option>
                            <option value="microsoft">Analyst 2</option>
                          </select>
                        </div>
                      </div> */}

                    {plan !== "basic" && (
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Key Words"
                            name="keyword"
                            id="keyword"
                            style={{ float: "left", width: "89%" }}
                          />
                          <button
                            type="button"
                            // style={{float:'left'}}
                            className="btn btn-primary btn-Icon"
                            onClick={() => handleClick("keyword")}
                          >
                            <i
                              className="fa fa-plus"
                              style={{ fontSize: "22px", color: "black" }}
                            ></i>
                          </button>
                        </div>
                      </div>
                    )}

                    {!isMSSP ? (
                      <div className="col-lg-6 col-md-12">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="inputGroupFile01"
                            onChange={handleLogoChange}
                            accept="image/*"
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                          >
                            {logo instanceof File ? logo.name : (logo && logo !== "" ? "Change logo" : "Upload logo")}
                          </label>
                        </div>
                        {logo && logo !== "" && !(logo instanceof File) && (
                          <small style={{ color: "#666", display: "block", marginTop: "5px" }}>
                            Current: Backend logo loaded
                          </small>
                        )}
                      </div>
                    ) : null}
                    {plan !== "basic" && (
                      <div className="col-lg-6 col-md-12">
                        {keyWord && keyWord.length > 0 && (
                          <div className="row">
                            {keyWord.map((keyword) => {
                              return (
                                <div className="col-md-4">
                                  <label
                                    style={{
                                      color: "white",
                                      background: "#2e2a74",
                                      padding: "4px 6px",
                                    }}
                                  >
                                    <span style={{ color: "#fff" }}>
                                      {keyword}{" "}
                                      <span
                                        className="fa fa-times-circle text-white"
                                        onClick={() =>
                                          removeKeyword("keyword", keyword)
                                        }
                                      ></span>
                                    </span>
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="col-lg-6 col-md-12">
                      {logo && logo != "" && (
                        <div className="col-lg-6 col-md-12">
                          <div className="row">
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <img
                                style={{ 
                                  width: "100px", 
                                  height: "100px", 
                                  objectFit: "cover",
                                  border: "2px solid #ddd",
                                  borderRadius: "8px"
                                }}
                                src={logo instanceof File ? URL.createObjectURL(logo) : 
                                     (logo.startsWith('http') ? logo : `${IMAGE_URL}${logo}`)}
                                alt="Organization Logo"
                              />
                              <span
                                className="fa fa-times-circle"
                                style={{
                                  position: "absolute",
                                  top: "-8px",
                                  right: "-8px",
                                  color: "red",
                                  backgroundColor: "white",
                                  borderRadius: "50%",
                                  cursor: "pointer",
                                  fontSize: "18px",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                }}
                                onClick={() => removeLogo()}
                                title="Remove logo"
                              ></span>
                            </div>
                            <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                              <small style={{ color: "#666" }}>
                                {logo instanceof File ? "New file selected" : "Current logo"}
                              </small>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <hr />
                  </div>
                  {clientType !== "3" && clientType !== 3 && (
                    <>
                      <h6>Service</h6>
                      <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 serviceBox">
                          <Autocomplete
                            style={{ width: "100%" }}
                            multiple
                            id="tags-outlined"
                            options={['AttackSurface', 'Data Exposure', 'BrandSecurity', 'TPSA', 'Active VA', 'ExecutiveMonitoring', 'RedTeaming', 'ThreatIntelligence']}
                            value={services}
                            onChange={(event, newValue) => {
                              setServices(newValue);
                            }}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                placeholder=""
                              />
                            )}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div>
                    <h6 style={{ marginTop: "20px" }}>VIP Monitoring</h6>
                    {/* Display entities if they exist */}
                    {vipEntities?.length > 0 && vipEntities.map((entity, entityIndex) => (
                      <div key={entityIndex} className="entity" style={{ marginBottom: '20px' }}>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name *"
                            value={entity?.name}
                            onChange={(e) => handleEntityChange(entityIndex, 'name', e.target.value)}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email *"
                            value={entity?.email}
                            onChange={(e) => handleEntityChange(entityIndex, 'email', e.target.value)}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Position"
                            value={entity?.position}
                            onChange={(e) => handleEntityChange(entityIndex, 'position', e.target.value)}
                          />
                        </div>

                        <p style={{ marginTop: "20px" }}>Social Media Profiles</p>
                        {Array.isArray(entity?.socialMediaProfiles) && entity.socialMediaProfiles.map((profile, profileIndex) => (
                          <div key={profileIndex} className="row">
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Username"
                                  value={profile?.username}
                                  onChange={(e) => handleSocialMediaChange(entityIndex, profileIndex, 'username', e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group d-flex">
                                {/* <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Platform"
                                  value={profile?.platform}
                                  onChange={(e) => handleSocialMediaChange(entityIndex, profileIndex, 'platform', e.target.value)}
                                /> */}
                                <select
                                  className="form-control"
                                  value={profile?.platform}
                                  onChange={(e) => handleSocialMediaChange(entityIndex, profileIndex, 'platform', e.target.value)}
                                >
                                  <option value="">Select Platform</option>
                                  <option value="Facebook">Facebook</option>
                                  <option value="Twitter">Twitter</option>
                                  <option value="LinkedIn">LinkedIn</option>
                                  <option value="Instagram">Instagram</option>
                                </select>
                                <button type="button" onClick={() => removeSocialMediaProfile(entityIndex, profileIndex)} className="btn btn-danger btn-sm" style={{ marginLeft: '10px' }}>
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                        <button type="button" onClick={() => addSocialMediaProfile(entityIndex)} className="btn btn-secondary" style={{ marginRight: "10px" }}>
                          Add Profile
                        </button>
                        <button type="button" onClick={() => removeEntity(entityIndex)} className="btn btn-danger" style={{ marginRight: "10px" }}>
                          Delete
                        </button>
                      </div>
                    ))}
                    {/* Always show the Add Entity button, with a note when no entities exist */}
                    {vipEntities?.length === 0 && (
                      <div className="alert alert-light" style={{ padding: '10px', marginBottom: '10px' }}>
                        No VIP entities added. Click "Add Entity" to add VIP monitoring.
                      </div>
                    )}
                    <button type="button" onClick={addNewEntity} className="btn btn-secondary" style={{ marginRight: "10px" }}>
                      {vipEntities?.length === 0 ? "Add Entity" : "New Entity"}
                    </button>
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    <h6>License Duration</h6>
                    &nbsp;&nbsp;
                    <div className="row clearfix">
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <div className="col-lg-12 col-md-12 clientCalendar">
                              <div className="form-group">
                                <DatePicker
                                  selected={expiredAt}
                                  minDate={new Date()}
                                  // showTimeSelect
                                  timeFormat="p"
                                  timeIntervals={1}
                                  onChange={(date) => selectDate(date)}
                                  className="form-control datetimepicker"
                                  dateFormat="MMMM d, yyyy h:mm aa"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr />
                    </div>
                  </div>


                  {/* Detailed Scan Configuration */}
                  {clientType !== "3" && clientType !== 3 && (
                    <div style={{ marginTop: "20px" }}>
                      <h6>Detailed Scan Configuration</h6>
                      <div className="row clearfix">
                        <div className="col-lg-12 col-md-12">

                          {/* Attack Surface Configuration */}
                          {services?.indexOf("AttackSurface") !== -1 && (
                            <div className="form-group" style={{ marginBottom: "20px" }}>
                              <h6 style={{ marginBottom: "10px" }}>Attack Surface</h6>
                              <div className="row">
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>IP Discovery</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('attackSurface', 'ipDiscovery', 'daily')}
                                    onChange={(e) => updateScanConfiguration('attackSurface', 'ipDiscovery', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Subdomain Enumeration</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('attackSurface', 'subDomainEnumeration', 'daily')}
                                    onChange={(e) => updateScanConfiguration('attackSurface', 'subDomainEnumeration', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>SPF & DMARC</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('attackSurface', 'spfAndDmarc', 'daily')}
                                    onChange={(e) => updateScanConfiguration('attackSurface', 'spfAndDmarc', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Data Exposure Configuration */}
                          {services?.indexOf("Data Exposure") !== -1 && (
                            <div className="form-group" style={{ marginBottom: "20px" }}>
                              <h6 style={{ marginBottom: "10px" }}>Data Exposure</h6>
                              <div className="row">
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Leaked Credentials</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'leakedCredentials', 'never')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'leakedCredentials', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Leaked Sessions</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'leakedSessions', 'never')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'leakedSessions', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Malware</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'malware', 'never')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'malware', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Leaked Source Code</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'leakedSourceCode', 'daily')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'leakedSourceCode', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Pastebin Search</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'pastebinSearch', 'daily')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'pastebinSearch', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Breached Personal Information</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'breachedPersonalInformation', 'daily')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'breachedPersonalInformation', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Telegram Monitoring</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'telegramMonitoring', 'daily')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'telegramMonitoring', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Postman Monitoring</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'postmanMonitoring', 'daily')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'postmanMonitoring', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Open Cloud Buckets</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'openCloudBuckets', 'daily')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'openCloudBuckets', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Dark Web Monitoring</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('dataExposure', 'darkWebMonitoring', 'daily')}
                                    onChange={(e) => updateScanConfiguration('dataExposure', 'darkWebMonitoring', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Brand Security Configuration */}
                          {services?.indexOf("BrandSecurity") !== -1 && (
                            <div className="form-group" style={{ marginBottom: "20px" }}>
                              <h6 style={{ marginBottom: "10px" }}>Brand Security</h6>
                              <div className="row">
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Look Alike Domains</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('brandSecurity', 'lookAlike', 'daily')}
                                    onChange={(e) => updateScanConfiguration('brandSecurity', 'lookAlike', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Rogue Mobile Apps</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('brandSecurity', 'rogueMobile', 'daily')}
                                    onChange={(e) => updateScanConfiguration('brandSecurity', 'rogueMobile', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Social Media Profiles</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('brandSecurity', 'socialMediaProfiles', 'daily')}
                                    onChange={(e) => updateScanConfiguration('brandSecurity', 'socialMediaProfiles', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label style={{ color: "#000", fontSize: "12px" }}>Brand Mentions</label>
                                  <select
                                    className="form-control form-control-sm"
                                    value={getScanConfigValue('brandSecurity', 'brandMentions', 'never')}
                                    onChange={(e) => updateScanConfiguration('brandSecurity', 'brandMentions', e.target.value)}
                                  >
                                    <option value="never">One Time</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div>
                    <h6>Social Media Information (Optional)</h6>
                    &nbsp;&nbsp;
                    <div className="row clearfix">
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-facebook"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="http://"
                              id="facebookUrl"
                              // value={facebookUrl}
                              style={{ float: "left", width: "86%" }}
                            // onChange={(e) => setFacebookUrl(e.target.value)}
                            />
                            <button
                              type="button"
                              style={{ float: "left" }}
                              className="btn btn-primary btn-Icon"
                              onClick={() => handleClick("facebook")}
                            >
                              <i
                                className="fa fa-plus"
                                style={{ fontSize: "22px", color: "black" }}
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-linkedin"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="http://"
                              id="liknedinUrl"
                              // value={linkedinUrl}
                              style={{ float: "left", width: "86%" }}
                            // onChange={(e) => setLinkedinUrl(e.target.value)}
                            />
                            <button
                              type="button"
                              style={{ float: "left" }}
                              className="btn btn-primary btn-Icon"
                              onClick={() => handleClick("linkedin")}
                            >
                              <i
                                className="fa fa-plus"
                                style={{ fontSize: "22px", color: "black" }}
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      {facebookUrl && facebookUrl.length > 0 && (
                        <div className="col-lg-6 col-md-12">
                          <div className="row">
                            {facebookUrl?.map((keyword) => {
                              if (keyword == "") return;
                              return (
                                <div className="col-md-4">
                                  <label
                                    style={{
                                      color: "white",
                                      background: "#2e2a74",
                                      padding: "4px 6px",
                                    }}
                                  >
                                    <span style={{ color: "#fff" }}>
                                      {keyword}{" "}
                                      <span
                                        className="fa fa-times-circle text-white"
                                        onClick={() =>
                                          removeKeyword("facebook", keyword)
                                        }
                                      ></span>
                                    </span>
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {linkedinUrl && linkedinUrl.length > 0 && (
                        <div className="col-lg-6 col-md-12">
                          <div className="row">
                            {linkedinUrl?.map((keyword) => {
                              if (keyword == "") return;
                              return (
                                <div className="col-md-4">
                                  <label
                                    style={{
                                      color: "white",
                                      background: "#2e2a74",
                                      padding: "4px 6px",
                                    }}
                                  >
                                    <span style={{ color: "#fff" }}>
                                      {keyword}{" "}
                                      <span
                                        className="fa fa-times-circle text-white"
                                        onClick={() =>
                                          removeKeyword("linkedin", keyword)
                                        }
                                      ></span>
                                    </span>
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-twitter"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="http://"
                              id="twitterUrl"
                              // value={twitterUrl}
                              style={{ float: "left", width: "86%" }}
                            // onChange={(e) => setTwitterUrl(e.target.value)}
                            />
                            <button
                              type="button"
                              style={{ float: "left" }}
                              className="btn btn-primary btn-Icon"
                              onClick={() => handleClick("twitter")}
                            >
                              <i
                                className="fa fa-plus"
                                style={{ fontSize: "22px", color: "black" }}
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-instagram"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="http://"
                              id="instagramUrl"
                              // value={instagramUrl}
                              style={{ float: "left", width: "86%" }}
                            // onChange={(e) =>
                            //   setInstagramUrl(e.target.value)
                            // }
                            />
                            <button
                              type="button"
                              style={{ float: "left" }}
                              className="btn btn-primary btn-Icon"
                              onClick={() => handleClick("instagram")}
                            >
                              <i
                                className="fa fa-plus"
                                style={{ fontSize: "22px", color: "black" }}
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      {twitterUrl && twitterUrl.length > 0 && (
                        <div className="col-lg-6 col-md-12">
                          <div className="row">
                            {twitterUrl?.map((keyword) => {
                              if (keyword == "") return;
                              return (
                                <div className="col-md-4">
                                  <label
                                    style={{
                                      color: "white",
                                      background: "#2e2a74",
                                      padding: "4px 6px",
                                    }}
                                  >
                                    <span style={{ color: "#fff" }}>
                                      {keyword}{" "}
                                      <span
                                        className="fa fa-times-circle text-white"
                                        onClick={() =>
                                          removeKeyword("twitter", keyword)
                                        }
                                      ></span>
                                    </span>
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {instagramUrl && instagramUrl.length > 0 && (
                        <div className="col-lg-6 col-md-12">
                          <div className="row">
                            {instagramUrl?.map((keyword) => {
                              if (keyword == "") return;
                              return (
                                <div className="col-md-4">
                                  <label
                                    style={{
                                      color: "white",
                                      background: "#2e2a74",
                                      padding: "4px 6px",
                                    }}
                                  >
                                    <span style={{ color: "#fff" }}>
                                      {keyword}{" "}
                                      <span
                                        className="fa fa-times-circle text-white"
                                        onClick={() =>
                                          removeKeyword("instagram", keyword)
                                        }
                                      ></span>
                                    </span>
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <hr />
                    </div>
                  </div>
                  {isEdit && (
                    <div>
                      <h6>Vendor Details</h6>
                      <div className="custom-file">
                        <input
                          type="file"
                          className="custom-file-input"
                          id="inputGroupFile02"
                          onChange={handleFileChange}
                        />
                        <label
                          className="custom-file-label"
                          htmlFor="inputGroupFile02"
                        >
                          Upload File
                        </label>
                      </div>
                    </div>
                  )}
                  <hr></hr>
                  <div>
                    <h6>Address information</h6>
                    &nbsp;&nbsp;
                    <div className="row clearfix">
                      <div className="col-lg-4 col-md-12">
                        <div className="form-group">
                          <select
                            className="form-control"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                          >
                            <option value="">-- Select Country --</option>
                            <option value="AF">Afghanistan</option>
                            <option value="AX">Ã…land Islands</option>
                            <option value="AL">Albania</option>
                            <option value="DZ">Algeria</option>
                            <option value="AS">American Samoa</option>
                            <option value="AD">Andorra</option>
                            <option value="AO">Angola</option>
                            <option value="AI">Anguilla</option>
                            <option value="AQ">Antarctica</option>
                            <option value="AG">Antigua and Barbuda</option>
                            <option value="AR">Argentina</option>
                            <option value="AM">Armenia</option>
                            <option value="AW">Aruba</option>
                            <option value="AU">Australia</option>
                            <option value="AT">Austria</option>
                            <option value="AZ">Azerbaijan</option>
                            <option value="BS">Bahamas</option>
                            <option value="BH">Bahrain</option>
                            <option value="BD">Bangladesh</option>
                            <option value="BB">Barbados</option>
                            <option value="BY">Belarus</option>
                            <option value="BE">Belgium</option>
                            <option value="BZ">Belize</option>
                            <option value="BJ">Benin</option>
                            <option value="BM">Bermuda</option>
                            <option value="BT">Bhutan</option>
                            <option value="BO">
                              Bolivia, Plurinational State of
                            </option>
                            <option value="BQ">
                              Bonaire, Sint Eustatius and Saba
                            </option>
                            <option value="BA">Bosnia and Herzegovina</option>
                            <option value="BW">Botswana</option>
                            <option value="BV">Bouvet Island</option>
                            <option value="BR">Brazil</option>
                            <option value="IO">
                              British Indian Ocean Territory
                            </option>
                            <option value="BN">Brunei Darussalam</option>
                            <option value="BG">Bulgaria</option>
                            <option value="BF">Burkina Faso</option>
                            <option value="BI">Burundi</option>
                            <option value="KH">Cambodia</option>
                            <option value="CM">Cameroon</option>
                            <option value="CA">Canada</option>
                            <option value="CV">Cape Verde</option>
                            <option value="KY">Cayman Islands</option>
                            <option value="CF">Central African Republic</option>
                            <option value="TD">Chad</option>
                            <option value="CL">Chile</option>
                            <option value="CN">China</option>
                            <option value="CX">Christmas Island</option>
                            <option value="CC">Cocos (Keeling) Islands</option>
                            <option value="CO">Colombia</option>
                            <option value="KM">Comoros</option>
                            <option value="CG">Congo</option>
                            <option value="CD">
                              Congo, the Democratic Republic of the
                            </option>
                            <option value="CK">Cook Islands</option>
                            <option value="CR">Costa Rica</option>
                            <option value="CI">CÃ´te d'Ivoire</option>
                            <option value="HR">Croatia</option>
                            <option value="CU">Cuba</option>
                            <option value="CW">CuraÃ§ao</option>
                            <option value="CY">Cyprus</option>
                            <option value="CZ">Czech Republic</option>
                            <option value="DK">Denmark</option>
                            <option value="DJ">Djibouti</option>
                            <option value="DM">Dominica</option>
                            <option value="DO">Dominican Republic</option>
                            <option value="EC">Ecuador</option>
                            <option value="EG">Egypt</option>
                            <option value="SV">El Salvador</option>
                            <option value="GQ">Equatorial Guinea</option>
                            <option value="ER">Eritrea</option>
                            <option value="EE">Estonia</option>
                            <option value="ET">Ethiopia</option>
                            <option value="FK">
                              Falkland Islands (Malvinas)
                            </option>
                            <option value="FO">Faroe Islands</option>
                            <option value="FJ">Fiji</option>
                            <option value="FI">Finland</option>
                            <option value="FR">France</option>
                            <option value="GF">French Guiana</option>
                            <option value="PF">French Polynesia</option>
                            <option value="TF">
                              French Southern Territories
                            </option>
                            <option value="GA">Gabon</option>
                            <option value="GM">Gambia</option>
                            <option value="GE">Georgia</option>
                            <option value="DE">Germany</option>
                            <option value="GH">Ghana</option>
                            <option value="GI">Gibraltar</option>
                            <option value="GR">Greece</option>
                            <option value="GL">Greenland</option>
                            <option value="GD">Grenada</option>
                            <option value="GP">Guadeloupe</option>
                            <option value="GU">Guam</option>
                            <option value="GT">Guatemala</option>
                            <option value="GG">Guernsey</option>
                            <option value="GN">Guinea</option>
                            <option value="GW">Guinea-Bissau</option>
                            <option value="GY">Guyana</option>
                            <option value="HT">Haiti</option>
                            <option value="HM">
                              Heard Island and McDonald Islands
                            </option>
                            <option value="VA">
                              Holy See (Vatican City State)
                            </option>
                            <option value="HN">Honduras</option>
                            <option value="HK">Hong Kong</option>
                            <option value="HU">Hungary</option>
                            <option value="IS">Iceland</option>
                            <option value="IN">India</option>
                            <option value="ID">Indonesia</option>
                            <option value="IR">
                              Iran, Islamic Republic of
                            </option>
                            <option value="IQ">Iraq</option>
                            <option value="IE">Ireland</option>
                            <option value="IM">Isle of Man</option>
                            <option value="IL">Israel</option>
                            <option value="IT">Italy</option>
                            <option value="JM">Jamaica</option>
                            <option value="JP">Japan</option>
                            <option value="JE">Jersey</option>
                            <option value="JO">Jordan</option>
                            <option value="KZ">Kazakhstan</option>
                            <option value="KE">Kenya</option>
                            <option value="KI">Kiribati</option>
                            <option value="KP">
                              Korea, Democratic People's Republic of
                            </option>
                            <option value="KR">Korea, Republic of</option>
                            <option value="KW">Kuwait</option>
                            <option value="KG">Kyrgyzstan</option>
                            <option value="LA">
                              Lao People's Democratic Republic
                            </option>
                            <option value="LV">Latvia</option>
                            <option value="LB">Lebanon</option>
                            <option value="LS">Lesotho</option>
                            <option value="LR">Liberia</option>
                            <option value="LY">Libya</option>
                            <option value="LI">Liechtenstein</option>
                            <option value="LT">Lithuania</option>
                            <option value="LU">Luxembourg</option>
                            <option value="MO">Macao</option>
                            <option value="MK">
                              Macedonia, the former Yugoslav Republic of
                            </option>
                            <option value="MG">Madagascar</option>
                            <option value="MW">Malawi</option>
                            <option value="MY">Malaysia</option>
                            <option value="MV">Maldives</option>
                            <option value="ML">Mali</option>
                            <option value="MT">Malta</option>
                            <option value="MH">Marshall Islands</option>
                            <option value="MQ">Martinique</option>
                            <option value="MR">Mauritania</option>
                            <option value="MU">Mauritius</option>
                            <option value="YT">Mayotte</option>
                            <option value="MX">Mexico</option>
                            <option value="FM">
                              Micronesia, Federated States of
                            </option>
                            <option value="MD">Moldova, Republic of</option>
                            <option value="MC">Monaco</option>
                            <option value="MN">Mongolia</option>
                            <option value="ME">Montenegro</option>
                            <option value="MS">Montserrat</option>
                            <option value="MA">Morocco</option>
                            <option value="MZ">Mozambique</option>
                            <option value="MM">Myanmar</option>
                            <option value="NA">Namibia</option>
                            <option value="NR">Nauru</option>
                            <option value="NP">Nepal</option>
                            <option value="NL">Netherlands</option>
                            <option value="NC">New Caledonia</option>
                            <option value="NZ">New Zealand</option>
                            <option value="NI">Nicaragua</option>
                            <option value="NE">Niger</option>
                            <option value="NG">Nigeria</option>
                            <option value="NU">Niue</option>
                            <option value="NF">Norfolk Island</option>
                            <option value="MP">Northern Mariana Islands</option>
                            <option value="NO">Norway</option>
                            <option value="OM">Oman</option>
                            <option value="PK">Pakistan</option>
                            <option value="PW">Palau</option>
                            <option value="PS">
                              Palestinian Territory, Occupied
                            </option>
                            <option value="PA">Panama</option>
                            <option value="PG">Papua New Guinea</option>
                            <option value="PY">Paraguay</option>
                            <option value="PE">Peru</option>
                            <option value="PH">Philippines</option>
                            <option value="PN">Pitcairn</option>
                            <option value="PL">Poland</option>
                            <option value="PT">Portugal</option>
                            <option value="PR">Puerto Rico</option>
                            <option value="QA">Qatar</option>
                            <option value="RE">RÃ©union</option>
                            <option value="RO">Romania</option>
                            <option value="RU">Russian Federation</option>
                            <option value="RW">Rwanda</option>
                            <option value="BL">Saint BarthÃ©lemy</option>
                            <option value="SH">
                              Saint Helena, Ascension and Tristan da Cunha
                            </option>
                            <option value="KN">Saint Kitts and Nevis</option>
                            <option value="LC">Saint Lucia</option>
                            <option value="MF">
                              Saint Martin (French part)
                            </option>
                            <option value="PM">
                              Saint Pierre and Miquelon
                            </option>
                            <option value="VC">
                              Saint Vincent and the Grenadines
                            </option>
                            <option value="WS">Samoa</option>
                            <option value="SM">San Marino</option>
                            <option value="ST">Sao Tome and Principe</option>
                            <option value="SA">Saudi Arabia</option>
                            <option value="SN">Senegal</option>
                            <option value="RS">Serbia</option>
                            <option value="SC">Seychelles</option>
                            <option value="SL">Sierra Leone</option>
                            <option value="SG">Singapore</option>
                            <option value="SX">
                              Sint Maarten (Dutch part)
                            </option>
                            <option value="SK">Slovakia</option>
                            <option value="SI">Slovenia</option>
                            <option value="SB">Solomon Islands</option>
                            <option value="SO">Somalia</option>
                            <option value="ZA">South Africa</option>
                            <option value="GS">
                              South Georgia and the South Sandwich Islands
                            </option>
                            <option value="SS">South Sudan</option>
                            <option value="ES">Spain</option>
                            <option value="LK">Sri Lanka</option>
                            <option value="SD">Sudan</option>
                            <option value="SR">Suriname</option>
                            <option value="SJ">Svalbard and Jan Mayen</option>
                            <option value="SZ">Swaziland</option>
                            <option value="SE">Sweden</option>
                            <option value="CH">Switzerland</option>
                            <option value="SY">Syrian Arab Republic</option>
                            <option value="TW">
                              Taiwan, Province of China
                            </option>
                            <option value="TJ">Tajikistan</option>
                            <option value="TZ">
                              Tanzania, United Republic of
                            </option>
                            <option value="TH">Thailand</option>
                            <option value="TL">Timor-Leste</option>
                            <option value="TG">Togo</option>
                            <option value="TK">Tokelau</option>
                            <option value="TO">Tonga</option>
                            <option value="TT">Trinidad and Tobago</option>
                            <option value="TN">Tunisia</option>
                            <option value="TR">Turkey</option>
                            <option value="TM">Turkmenistan</option>
                            <option value="TC">Turks and Caicos Islands</option>
                            <option value="TV">Tuvalu</option>
                            <option value="UG">Uganda</option>
                            <option value="UA">Ukraine</option>
                            <option value="AE">United Arab Emirates</option>
                            <option value="GB">United Kingdom</option>
                            <option value="US">United States</option>
                            <option value="UM">
                              United States Minor Outlying Islands
                            </option>
                            <option value="UY">Uruguay</option>
                            <option value="UZ">Uzbekistan</option>
                            <option value="VU">Vanuatu</option>
                            <option value="VE">
                              Venezuela, Bolivarian Republic of
                            </option>
                            <option value="VN">Viet Nam</option>
                            <option value="VG">Virgin Islands, British</option>
                            <option value="VI">Virgin Islands, U.S.</option>
                            <option value="WF">Wallis and Futuna</option>
                            <option value="EH">Western Sahara</option>
                            <option value="YE">Yemen</option>
                            <option value="ZM">Zambia</option>
                            <option value="ZW">Zimbabwe</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="State/Province"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="City"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <textarea
                            rows="4"
                            type="text"
                            className="form-control"
                            placeholder="Address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          ></textarea>
                        </div>
                      </div>

                      <hr />
                    </div>
                  </div>

                  <button
                    type="button"
                    style={{ color: "black", fontWeight: "bold" }}
                    className="btn btn-round btn-primary mr-1"
                    onClick={submitForm}
                  >
                    {isEdit ? "Update" : "Create"}
                  </button>{" "}
                  &nbsp;&nbsp;
                  <button type="button"
                    onClick={() => setModal("")}
                    className="btn btn-round btn-default">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade  ${refreshModal ? "d-block show" : ""}`}
        id="exampleModal"
        onClick={() => setRefreshModal(false)}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Refresh Client?
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to refresh?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-round btn-default"
                data-dismiss="modal"
                onClick={() => setRefreshModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-round btn-primary"
                onClick={() => {
                  refreshCustomer(selectedOrgId);
                  setRefreshModal(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Detailed Scan Configuration Modal */}
      <div
        className={`modal fade ${showDetailedScanConfig ? "d-block show" : ""}`}
        id="detailedScanConfigModal"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Detailed Scan Configuration</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowDetailedScanConfig(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              {scanConfiguration && (
                <div className="row">
                  {/* Attack Surface Section */}
                  <div className="col-12 mb-4">
                    <h6 className="text-primary">Attack Surface</h6>
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>IP Discovery</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('attackSurface', 'ipDiscovery', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Sub Domain Enumeration</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('attackSurface', 'subDomainEnumeration', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>SPF and DMARC</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('attackSurface', 'spfAndDmarc', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Data Exposure Section */}
                  <div className="col-12 mb-4">
                    <h6 className="text-primary">Data Exposure</h6>
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Leaked Credentials</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'leakedCredentials', 'never')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Leaked Sessions</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'leakedSessions', 'never')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Malware</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'malware', 'never')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Leaked Source Code</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'leakedSourceCode', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Pastebin Search</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'pastebinSearch', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Breached Personal Information</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'breachedPersonalInformation', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Telegram Monitoring</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'telegramMonitoring', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Postman Monitoring</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'postmanMonitoring', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Open Cloud Buckets</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'openCloudBuckets', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Dark Web Monitoring</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('dataExposure', 'darkWebMonitoring', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Brand Security Section */}
                  <div className="col-12 mb-4">
                    <h6 className="text-primary">Brand Security</h6>
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Look Alike Domains</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('brandSecurity', 'lookAlike', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Rogue Mobile Apps</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('brandSecurity', 'rogueMobile', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Social Media Profiles</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('brandSecurity', 'socialMediaProfiles', 'daily')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label style={{ color: "#000", fontSize: "12px" }}>Brand Mentions</label>
                        <select
                          className="form-control form-control-sm"
                          value={getScanConfigValue('brandSecurity', 'brandMentions', 'never')}
                          disabled
                        >
                          {renderScanFrequencyOptions()}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-round btn-default"
                onClick={() => setShowDetailedScanConfig(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scan Configuration Modal */}
      <div
        className={`modal fade ${scanConfigModal ? "d-block show" : ""}`}
        id="scanConfigModal"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Scan Configuration - {selectedClientForScanConfig?.orgName}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setScanConfigModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>IP Discovery</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('attackSurface', 'ipDiscovery', 'daily')}
                        onChange={(e) => updateScanConfiguration('attackSurface', 'ipDiscovery', e.target.value)}
                      >
                        <option value="never">One Time</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Subdomain Enumeration</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('attackSurface', 'subDomainEnumeration', 'daily')}
                        onChange={(e) => updateScanConfiguration('attackSurface', 'subDomainEnumeration', e.target.value)}
                      >
                        <option value="never">One Time</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>SPF & DMARC</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('attackSurface', 'spfAndDmarc', 'daily')}
                        onChange={(e) => updateScanConfiguration('attackSurface', 'spfAndDmarc', e.target.value)}
                      >
                        <option value="never">One Time</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Leaked Credentials</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'leakedCredentials', 'never')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'leakedCredentials', e.target.value)}
                      >
                        <option value="never">One Time</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Leaked Sessions</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'leakedSessions', 'never')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'leakedSessions', e.target.value)}
                      >
                        <option value="never">One Time</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Malware</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'malware', 'never')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'malware', e.target.value)}
                      >
                        <option value="never">One Time</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Leaked Source Code</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'leakedSourceCode', 'daily')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'leakedSourceCode', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Pastebin Search</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'pastebinSearch', 'daily')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'pastebinSearch', e.target.value)}
                      >
                        <option value="never">One Time</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Breached Personal Info</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'breachedPersonalInformation', 'daily')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'breachedPersonalInformation', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Telegram Monitoring</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'telegramMonitoring', 'daily')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'telegramMonitoring', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Postman Monitoring</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'postmanMonitoring', 'daily')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'postmanMonitoring', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Open Cloud Buckets</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'openCloudBuckets', 'daily')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'openCloudBuckets', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Dark Web Monitoring</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('dataExposure', 'darkWebMonitoring', 'daily')}
                        onChange={(e) => updateScanConfiguration('dataExposure', 'darkWebMonitoring', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Look Alike Domains</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('brandSecurity', 'lookAlike', 'daily')}
                        onChange={(e) => updateScanConfiguration('brandSecurity', 'lookAlike', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Rogue Mobile Apps</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('brandSecurity', 'rogueMobile', 'daily')}
                        onChange={(e) => updateScanConfiguration('brandSecurity', 'rogueMobile', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Social Media Profiles</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('brandSecurity', 'socialMediaProfiles', 'daily')}
                        onChange={(e) => updateScanConfiguration('brandSecurity', 'socialMediaProfiles', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label style={{ color: "#000", fontSize: "12px" }}>Brand Mentions</label>
                      <select
                        className="form-control form-control-sm"
                        value={getScanConfigValue('brandSecurity', 'brandMentions', 'never')}
                        onChange={(e) => updateScanConfiguration('brandSecurity', 'brandMentions', e.target.value)}
                      >
                        <option value="never">Never</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="bi-weekly">Bi-weekly</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-round btn-default"
                onClick={() => setScanConfigModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-round btn-primary"
                onClick={saveScanConfiguration}
              >
                Save Configuration
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
